import React from 'react';
import PropTypes from 'prop-types';

import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import UnifyButton from '../../../../../components/Button';
import { N400, Y400 } from '../../../../../components/Colors';

const ModalFilter = ({
  filter, setFilter, show, handleClose, handleApplyFilter,
}) => {
  const change = (e) => {
    const newFilter = { ...filter };
    newFilter[e.target.name] = e.target.value;
    setFilter(newFilter);
  };
  return (
    <Modal centered show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Tambah Filter</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group controlId="validationFormik01">
          <Form.Label>Jenis Kegiatan</Form.Label>

          <Form.Control
            type="text"
            as="select"
            data-testid="jenis_kegiatan"
            name="jenis_kegiatan"
            onChange={(e) => { change(e, 'jenis_kegiatan'); }}
            value={filter.jenis_kegiatan}
            placeholder="Pilih jenis kegiatan"
          >
            <option value="">Pilih jenis kegiatan</option>
            <option value="kuliah umum">kuliah umum</option>
            <option value="seminar ilmiah">seminar ilmiah</option>
          </Form.Control>
        </Form.Group>

        <Form.Group controlId="validationFormik01">
          <Form.Label>Tanggal</Form.Label>

          <Form.Control
            type="date"
            name="tanggal"
            data-testid="tanggal"
            onChange={(e) => { change(e); }}
            value={filter.tanggal}
          />

        </Form.Group>

        <Form.Group controlId="validationFormik01">
          <Form.Label>Penyelenggara</Form.Label>

          <Form.Control
            type="text"
            name="penyelenggara"
            data-testid="penyelenggara"
            value={filter.penyelenggara}
            onChange={(e) => {
              change(e);
            }}
          />
        </Form.Group>

      </Modal.Body>
      <Modal.Footer>
        <UnifyButton color="#CED4DA" textColor={N400} onClick={handleClose}>
          Batal
        </UnifyButton>
        <UnifyButton color={Y400} textColor={N400} onClick={handleApplyFilter}>
          Terapkan
        </UnifyButton>
      </Modal.Footer>
    </Modal>
  );
};

ModalFilter.propTypes = {
  show: PropTypes.bool.isRequired,
  handleApplyFilter: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  setFilter: PropTypes.func.isRequired,
  filter: PropTypes.shape({
    jenis_kegiatan: '', nama_kegiatan: 0, tanggal: '', penyelenggara: '',
  }).isRequired,
};

export default ModalFilter;
